import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/searchHoofdnetOpdrachten'
import type { HoofdnetOpdrachtenSearch } from '../types/HoofdnetOpdrachtenSearch'

export { useHoofdnetOpdrachtenSearchStore }

const useHoofdnetOpdrachtenSearchStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<HoofdnetOpdrachtenSearch['query']>>(
  (set) => ({
    query: initialState.query,
    storeQuery: (query) =>
      set((state) => ({ query: { ...state.query, ...query } })),
  }),
)
